import { replaceAnnouncementTokens } from "./announcementLink";

export const convertAnnouncementLinkIntoHref = (description: string): string =>
	replaceAnnouncementTokens(description);
